<template>
  <sidebar-layout>
    <router-view />
  </sidebar-layout>
</template>

<script>
  import SidebarLayout from '@/layouts/SidebarLayout'

  export default {
    name: 'BackOfficeRouterView',
    components: { SidebarLayout },
  }
</script>
